import { useMemo } from "react";
import { useApiClient } from "../../../shared/customHooks";
import { supportTypeForm } from "../../../shared/formObjects/application/supportTypeForm";
import { INavItem } from "../../../shared/GlobalContext";
import { useApplicationContext } from "../context/applicationContext";
import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

function SupportTypeComponent({ disabled, data }: any) {
  const api = useApiClient("SupportType");
  const { id, applicationBase } = useApplicationContext();

  const formContext = useMemo(() => ({ isComplex: applicationBase.applicationType.applicationCategory === 0 }), []);

  const customNav: INavItem = {
    label: "Type of Support",
    id: "TypeOfSupport",
    items: [
      {
        label: "Additional Assistant",
        id: "additionalAssistantSupportType",
      },
      {
        label: "Specialist Consultancy",
        id: "specialistConsultancySupportType",
      },
      {
        label: "Specialist Training",
        id: "specialistTrainingSupportType",
      },
      {
        label: "Minor Building Modifications",
        id: "minorWorksSupportType",
      },
    ],
  };
  return (
    <BaseApplicationComponent
      formBody={supportTypeForm}
      headerLabel="Type of Support"
      editPath="supportType"
      apiClient={api}
      disabled={disabled}
      data={data}
      customNav={customNav}
      formContext={formContext}
      id={id}
    />
  );
}

export default SupportTypeComponent;
